import React from 'react';
import { dealerLogos } from '../data/site';
export function DealerBand() {
  return <section aria-label="Authorized dealer" className="gutter w-full border-b border-navy/10 bg-white py-10 md:py-14" data-id="element-77" data-mp="39rxi60vlu8i9">
      <div className="flex flex-col items-center gap-8 md:flex-row md:justify-between" data-id="element-78" data-mp="3nroxq61rrwyd">
        <p className="display order-2 text-center text-2xl font-semibold text-navy md:order-1 md:max-w-[26ch] md:text-left md:text-3xl 3xl:text-4xl" data-id="element-79" data-mp="3iru6u2hzv7db">
          Full-line authorized dealer for new motors, repowers and genuine parts.
        </p>
        <div className="order-1 flex items-center gap-10 md:order-2 md:gap-16 3xl:gap-24" data-id="element-80" data-mp="3sq9qxliltgdb">
          {dealerLogos.map(l => <img key={l.name} src={l.src} alt={`${l.name} authorized dealer logo`} className="h-14 w-auto max-w-[220px] object-contain md:h-20 3xl:h-24" loading="lazy" data-id="element-81" data-mp="6axc15l9k7x5" />)}
        </div>
      </div>
    </section>;
}